import React, { PropsWithChildren, useState, useEffect } from 'react';

type Props = {
  value: number;
  handleInputChangePrice: (price: number, id: number, reference: string, buy_price: number) => void;
  id: number;
  reference: string;
  buy_price: number;
  disabled?: boolean;
  className?: string;
};

const PriceInput: React.FC<PropsWithChildren<Props>> = (props) => {
  const [value, setValue] = useState(props.value);

  // Sincronizare când props.value se schimbă (ex: update extern)
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, id: number, reference: string, buy_price: number) => {
    const inputValue = e.target.value;

    if (inputValue === '') {
      setValue(0);
      props.handleInputChangePrice(0, id, reference, buy_price);
    } else {
      const numericValue = parseFloat(inputValue.replace(',', '.'));

      if (!isNaN(numericValue)) {
        setValue(numericValue);
        props.handleInputChangePrice(numericValue, id, reference, buy_price);
      }
    }
  };

  return (
    <input
      type="number"
      step="0.1"
      onChange={(e) => handleInputChange(e, props.id, props.reference, props.buy_price)}
      value={value}
      disabled={props.disabled}
      min={0}
      className={props.className ? props.className : 'number-input'}
    />
  );
};

PriceInput.displayName = 'PriceInput';

export default PriceInput;
